import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createProject } from 'shared/thunks/admin/createProject';
import { updateProject } from 'shared/thunks/admin/updateProject';

type TProjectModalState = {
  isOpen: boolean;
  isLoading: boolean;
  id: number | null;
  title: string;
  description: string;
  seoPath: string;
  seoTitle: string;
  seoDescription: string;
};

const initialState: TProjectModalState = {
  isOpen: false,
  isLoading: false,
  id: null,
  title: '',
  description: '',
  seoPath: '',
  seoTitle: '',
  seoDescription: '',
};

type TProjectModalPayload = {
  id: number;
  title: string;
  description: string;
  seoPath: string;
  seoTitle: string;
  seoDescription: string;
};

const projectModalSlice = createSlice({
  name: 'projectModal',
  initialState,
  reducers: {
    openProjectModal: (state, action: PayloadAction<TProjectModalPayload | undefined>) => {
      state.isOpen = true;

      if (action.payload) {
        state.id = action.payload.id;
        state.title = action.payload.title;
        state.description = action.payload.description;
        state.seoPath = action.payload.seoPath;
        state.seoTitle = action.payload.seoTitle;
        state.seoDescription = action.payload.seoDescription;
      }
    },
    closeProjectModal: () => {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(createProject.pending, state => {
        state.isLoading = true;
      })
      .addCase(createProject.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(createProject.rejected, state => {
        state.isLoading = false;
      })
      .addCase(updateProject.pending, state => {
        state.isLoading = true;
      })
      .addCase(updateProject.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(updateProject.rejected, state => {
        state.isLoading = false;
      });
  },
});

export const { openProjectModal, closeProjectModal } = projectModalSlice.actions;

export const { reducer: projectModalReducer } = projectModalSlice;
